import { useWatch } from 'react-hook-form';
import { Alert, ListItemText } from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const SchedulePreview = ({ name, hasErrors }) => {
    const scheduleDetails = useWatch({ name });


    const textProps = {
        primary: scheduleDetails?.nimi || 'Uusi tilaisuus (muokkaa)',
        secondary: (() => {
            const aloitusTime = scheduleDetails?.aloitus && dayjs(scheduleDetails.aloitus).isValid()
                ? dayjs(scheduleDetails.aloitus).format('HH:mm')
                : 'Ei aikaa';
            const lopetusTime = scheduleDetails?.lopetus && dayjs(scheduleDetails.lopetus).isValid()
                ? dayjs(scheduleDetails.lopetus).format('HH:mm')
                : '';
            return `${aloitusTime}${lopetusTime ? ` - ${lopetusTime}` : ''}`;
        })(),
    };

    if (hasErrors) {
        return (
            <Alert severity='warning'>
                Tilaisuudelta puuttuu tietoja. Klikkaa muokataksesi.
            </Alert>
        );
    }

    return (
        <ListItemText
            {...textProps}
            sx={{ ml: 1 }}
            primaryTypographyProps={{ variant: 'h6' }}
            secondaryTypographyProps={{ variant: 'overline' }}
        />
    );
};

SchedulePreview.propTypes = {
    name: PropTypes.string,
    hasErrors: PropTypes.bool
};

export default SchedulePreview;